//@flow
//Action Type Registered
export const DEIMOS_INV_SUBMIT_SUCCESS='DEIMOS_INV_SUBMIT_SUCCESS'
export const DEIMOS_INV_SUBMIT_ERROR='DEIMOS_INV_SUBMIT_ERROR'
export const DEIMOS_INV_SUBMITTED_COMPLETED='DEIMOS_INV_SUBMITTED_COMPLETED'
export const DEIMOS_EDIT_VERIFY_FORM_DATA_SUCCESS='DEIMOS_EDIT_VERIFY_FORM_DATA_SUCCESS'
export const DEIMOS_EDIT_VERIFY_FORM_DATA_ERROR='DEIMOS_EDIT_VERIFY_FORM_DATA_ERROR'
export const DEIMOS_UPDATE_FORM_ERROR='DEIMOS_UPDATE_FORM_ERROR'
export const REFRESH_DEIMOS_VENDORS_SUCCESS='REFRESH_DEIMOS_VENDORS_SUCCESS'
export const REFRESH_DEIMOS_VENDORS_ERROR='REFRESH_DEIMOS_VENDORS_ERROR'
export const GET_DEIMOS_ITEMS_SUCCESS='GET_DEIMOS_ITEMS_SUCCESS';
export const GET_DEIMOS_ITEMS_ERROR='GET_DEIMOS_ITEMS_ERROR';
export const CREATE_NEW_DEIMOS_ITEM_SUCCESS='CREATE_NEW_DEIMOS_ITEM_SUCCESS';
export const CREATE_NEW_DEIMOS_ITEM_ERROR='CREATE_NEW_DEIMOS_ITEM_ERROR';
export const EDIT_DEIMOS_ITEM='EDIT_DEIMOS_ITEM';
export const UPDATE_DEIMOS_ITEM_SUCCESS='UPDATE_DEIMOS_ITEM_SUCCESS';
export const UPDATE_DEIMOS_ITEM_ERROR='UPDATE_DEIMOS_ITEM_ERROR';
export const MOVE_DOWN_DEIMOS_ITEM_SUCCESS='MOVE_DOWN_DEIMOS_ITEM_SUCCESS';
export const MOVE_DOWN_DEIMOS_ITEM_ERROR='MOVE_DOWN_DEIMOS_ITEM_ERROR';
export const MOVE_UP_DEIMOS_ITEM_SUCCESS='MOVE_UP_DEIMOS_ITEM_SUCCESS';
export const MOVE_UP_DEIMOS_ITEM_ERROR='MOVE_UP_DEIMOS_ITEM_ERROR';
export const DELETE_DEIMOS_ITEM_SUCCESS='DELETE_DEIMOS_ITEM_SUCCESS';
export const DELETE_DEIMOS_ITEM_ERROR='DELETE_DEIMOS_ITEM_ERROR';
export const SELECTED_DEIMOS_ITEM_ID='SELECTED_DEIMOS_ITEM_ID';
export const REFRESH_DEIMOS_ITEM='REFRESH_DEIMOS_ITEM';
export const OPEN_ADD_EDIT_LINEITEM_FORM='DEIMOS_OPEN_ADD_EDIT_LINEITEM_FORM'
export const CANCEL_ADD_EDIT_LINEITEN_FORM='DEIMOS_CANCEL_ADD_EDIT_LINEITEN_FORM'


// WEBPACK FOOTER //
// ./src/redux/deimos/actionTypes.js